<template>
  <el-dialog :title="'黑名单管理' + (comname ? '（' + comname + '）' : '')" :visible.sync="dialogVisible"
             width="960px" @close="handleClose" append-to-body>
    <div v-loading="importLoading" element-loading-text="正在导入，请稍候...">
      <div class="toolbar">
        <div class="toolbar-left">
          <el-input v-model.trim="keyword" placeholder="搜索公司名称/统一信用代码" clearable
                    @keyup.enter.native="search" @clear="search"></el-input>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
          <el-checkbox v-model="onlyBlack" @change="search">只显示黑名单</el-checkbox>
        </div>
        <el-upload action="" :show-file-list="false" :before-upload="beforeUpload" accept=".xlsx,.xls">
          <el-button type="success">导入Excel</el-button>
        </el-upload>
        <el-button type="info" @click="downloadTemplate">导入模板下载</el-button>
      </div>

      <el-table :data="list" border v-loading="loading" class="bl-table">
        <el-table-column prop="comfullname" label="单位名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="comidcode" label="统一信用代码" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="blstartdate" label="开始日期" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.blstartdate ? fmtDateOnly(scope.row.blstartdate) : '-' }}</template>
        </el-table-column>
        <el-table-column prop="blenddate" label="结束日期" width="100" align="center">
          <template slot-scope="scope">{{ !scope.row.blid ? '-' : (scope.row.blenddate ? fmtDateOnly(scope.row.blenddate) : '永久') }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row)" size="mini" class="status-tag">{{ statusText(scope.row) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="132" align="center">
          <template slot-scope="scope">
            <div class="operate-btns">
              <template v-if="!scope.row.blid">
                <el-button type="primary" size="mini" @click="openAddRow(scope.row)">拉黑</el-button>
              </template>
              <template v-else>
                <el-button type="danger" size="mini" @click="remove(scope.row)">移除</el-button>
                <el-button type="primary" size="mini" @click="openEdit(scope.row)">修改</el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top:10px;text-align:right" @current-change="pagechange"
                     :current-page="page" :page-size="limit" :total="total"
                     layout="total, prev, pager, next"></el-pagination>
    </div>

    <!-- 新增 / 修改 黑名单 -->
    <el-dialog :title="formTitle" :visible.sync="editVisible" width="460px" append-to-body @close="editVisible=false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="单位" v-if="!form.blid && !form.blcomid">
          <el-select v-model="form.blcomid" filterable placeholder="选择要拉黑的单位" style="width:100%" @change="onUnitChange">
            <el-option v-for="c in candidateComs" :key="c.comid"
                       :label="c.comfullname + ' / ' + (c.comidcode || '-')"
                       :value="c.comid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位" v-else>
          <span>{{ form.comfullname || form.blcomid }}</span>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker v-model="form.blstartdate" type="date" value-format="yyyy-MM-dd"
                          placeholder="选择开始日期" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="form.blenddate" type="date" value-format="yyyy-MM-dd"
                          placeholder="留空=永久生效" style="width:100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="原因/备注">
          <el-input v-model="form.blremark" type="textarea" :rows="3" placeholder="拉黑原因"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editVisible=false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <!-- 导入结果说明 -->
    <el-dialog title="导入结果" :visible.sync="importResultVisible" width="560px" append-to-body @close="importResultVisible=false">
      <el-alert v-if="importDetails.length" :type="importDetails.some(d => d.status === 'skipped') ? 'warning' : 'success'"
                :closable="false" show-icon
                :title="'共处理 ' + importSummary.total + ' 条，新增 ' + importSummary.success + ' 条，更新 ' + importSummary.updated + ' 条，跳过 ' + importSummary.skip + ' 条，剔除 ' + importSummary.removed + ' 条'">
      </el-alert>
      <div class="result-filter">
        <el-radio-group v-model="importFilter" size="mini" @change="importPage = 1">
          <el-radio-button label="all">全部 ({{ importDetails.length }})</el-radio-button>
          <el-radio-button label="success">成功 ({{ importSummary.success + importSummary.updated }})</el-radio-button>
          <el-radio-button label="skipped">未找到 ({{ importSummary.skip }})</el-radio-button>
          <el-radio-button label="removed">剔除 ({{ importSummary.removed }})</el-radio-button>
        </el-radio-group>
      </div>
      <el-table :data="importPaged" border style="margin-top:8px;max-height:320px;overflow:auto">
        <el-table-column prop="comfullname" label="单位名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="结果" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'success' ? 'success' : (scope.row.status === 'removed' ? 'warning' : 'info')" size="mini">
              {{ scope.row.status === 'success' ? '成功' : (scope.row.status === 'removed' ? '剔除' : '跳过') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="说明" min-width="160" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination style="margin-top:10px;text-align:right" @current-change="importPageChange"
                     :current-page="importPage" :page-size="importPageSize" :total="importFiltered.length"
                     layout="total, prev, pager, next" small></el-pagination>
      <span slot="footer">
        <el-button v-if="importSummary.skip > 0" type="warning" @click="exportErrors">导出未找到清单</el-button>
        <el-button v-if="importSummary.removed > 0" type="danger" plain @click="exportRemoved">导出剔除清单</el-button>
        <el-button type="primary" @click="importResultVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getBlacklist, addBlacklist, updateBlacklist, removeBlacklist, importBlacklist } from '@/api/blacklist'
import * as XLSX from 'xlsx'

export default {
  name: 'blacklistDialog',
  props: {
    visible: { type: Boolean, default: false },
    comid: { type: [Number, String], default: 0 },
    comname: { type: String, default: '' }
  },
  data () {
    return {
      dialogVisible: false,
      keyword: '',
      onlyBlack: true,
      list: [],
      total: 0,
      page: 1,
      limit: 20,
      loading: false,
      candidateComs: [],
      // 导入结果
      importResultVisible: false,
      importDetails: [],
      importSummary: { success: 0, updated: 0, skip: 0, removed: 0, total: 0 },
      importLoading: false,
      importFilter: 'all',
      importPage: 1,
      importPageSize: 20,
      // 表单
      editVisible: false,
      formTitle: '拉黑',
      form: { blid: 0, blcomid: '', blstartdate: '', blenddate: '', blremark: '', comfullname: '' }
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        this.page = 1
        this.keyword = ''
        this.onlyBlack = true
        this.loadData()
      }
    }
  },
  computed: {
    // 按筛选条件过滤导入结果明细
    importFiltered () {
      if (this.importFilter === 'all') return this.importDetails
      if (this.importFilter === 'success') return this.importDetails.filter(d => d.status === 'success')
      if (this.importFilter === 'skipped') return this.importDetails.filter(d => d.status === 'skipped')
      if (this.importFilter === 'removed') return this.importDetails.filter(d => d.status === 'removed')
      return this.importDetails
    },
    // 当前页要展示的明细（分页）
    importPaged () {
      let start = (this.importPage - 1) * this.importPageSize
      return this.importFiltered.slice(start, start + this.importPageSize)
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:visible', false)
    },
    // 是否已过期：结束日期 < 今天（按日期比对，不依赖后端 isblack）
    isExpired (row) {
      if (!row.blenddate) return false
      let d = new Date(String(row.blenddate).replace(' ', 'T').slice(0, 10))
      if (isNaN(d.getTime())) return false
      let t = new Date()
      t.setHours(0, 0, 0, 0)
      return d < t
    },
    statusText (row) {
      if (!row.blid) return '未入黑名单'
      if (!row.blenddate) return '永久'
      if (this.isExpired(row)) return '已失效'
      return '有效期'
    },
    statusType (row) {
      if (!row.blid) return 'info'
      if (!row.blenddate) return 'warning'
      if (this.isExpired(row)) return 'info'
      return 'danger'
    },
    async loadData () {
      if (!this.comid) return
      this.loading = true
      try {
        let res = await getBlacklist({
          comid: this.comid,
          keyword: this.keyword,
          onlyBlack: this.onlyBlack,
          limit: this.limit,
          offset: (this.page - 1) * this.limit
        })
        this.list = res.list || []
        this.total = res.total || 0
      } finally {
        this.loading = false
      }
    },
    search () {
      this.page = 1
      this.loadData()
    },
    reset () {
      this.page = 1
      this.keyword = ''
      this.loadData()
    },
    pagechange (p) {
      this.page = p
      this.loadData()
    },
    // 行内「拉黑」：直接对该单位入黑名单（单位已确定，无需再选）
    openAddRow (row) {
      this.formTitle = '拉黑'
      this.form = { blid: 0, blcomid: row.comid, blstartdate: '', blenddate: '', blremark: '', comfullname: row.comfullname }
      this.candidateComs = []
      this.editVisible = true
    },
    onUnitChange (val) {
      let c = this.candidateComs.find(x => x.comid === val)
      this.form.comfullname = c ? c.comfullname : ''
    },
    openEdit (row) {
      this.formTitle = '修改'
      this.form = {
        blid: row.blid,
        blcomid: row.comid,
        comfullname: row.comfullname,
        blstartdate: this.fmtDateOnly(row.blstartdate) || '',
        blenddate: this.fmtDateOnly(row.blenddate) || '',
        blremark: row.blremark || ''
      }
      this.candidateComs = []
      this.editVisible = true
    },
    async submitForm () {
      if (!this.form.blid && !this.form.blcomid) {
        this.$message.warning('请选择要加入黑名单的单位！')
        return
      }
      // 新增与修改均要求填写开始日期；结束日期、备注为非必填
      if (!this.form.blstartdate) {
        this.$message.warning('请填写开始日期！')
        return
      }
      let bluserid = (this.$store.getters.loginUser || {}).userid
      let data
      if (this.form.blid) {
        data = await updateBlacklist({
          blid: this.form.blid,
          blstartdate: this.form.blstartdate,
          blenddate: this.form.blenddate,
          blremark: this.form.blremark
        })
      } else {
        data = await addBlacklist({
          bltocomid: this.comid,
          blcomid: this.form.blcomid,
          blstartdate: this.form.blstartdate,
          blenddate: this.form.blenddate,
          blremark: this.form.blremark,
          bluserid
        })
      }
      if (data.issuccess === 1) {
        this.$message.success(data.msg)
        this.editVisible = false
        this.loadData()
      } else {
        this.$message.warning(data.msg)
      }
    },
    async remove (row) {
      try {
        await this.$confirm('确定将该单位【移出】黑名单吗?', '提示', { type: 'warning' })
      } catch (e) { return }
      let data = await removeBlacklist({ blid: row.blid })
      if (data.issuccess === 1) {
        this.$message.success(data.msg)
        this.loadData()
      } else {
        this.$message.warning(data.msg)
      }
    },
    beforeUpload (file) {
      let reader = new FileReader()
      reader.onload = (e) => {
        let wb = XLSX.read(e.target.result, { type: 'binary' })
        let ws = wb.Sheets[wb.SheetNames[0]]
        // blankrows:false 过滤完全空白行；有格式但无内容的行仍由 doImport 二次过滤
        let rows = XLSX.utils.sheet_to_json(ws, { blankrows: false })
        this.doImport(rows)
      }
      reader.readAsBinaryString(file)
      return false
    },
    downloadTemplate () {
      const url = 'http://120.78.91.121:9600/upload/20260831/1788163646771.xlsx'
      const a = document.createElement('a')
      a.href = url
      a.download = '导入模板.xlsx'
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    async doImport (rows) {
      if (!rows.length) {
        this.$message.warning('Excel 中没有数据！')
        return
      }
      let data = rows.map(r => {
        let keys = Object.keys(r)
        let get = (...names) => {
          for (let n of names) {
            let k = keys.find(k => k && k.indexOf(n) !== -1)
            if (k) return r[k]
          }
          return ''
        }
        return {
          blcomid: get('单位ID', 'comid', 'blcomid'),
          comfullname: get('单位名称', '公司名称', 'comfullname'),
          blstartdate: this.fmtDate(get('生效开始', '开始', 'start')),
          blenddate: this.fmtDate(get('生效结束', '结束', 'end')),
          blremark: get('备注', '原因', 'remark')
        }
      }).filter(r => r.blcomid || r.comfullname)
      if (!data.length) {
        this.$message.warning('Excel 中没有找到有效的单位数据（缺少单位ID或公司名称）！')
        return
      }
      this.importLoading = true
      try {
        let res = await importBlacklist({
          comid: this.comid,
          rows: data,
          bluserid: (this.$store.getters.loginUser || {}).userid
        })
        if (res.issuccess === 1) {
          this.importDetails = res.details || []
          this.importSummary = {
            success: res.success || 0,
            updated: res.updated || 0,
            skip: res.skip || 0,
            removed: res.removed || 0,
            total: (res.details || []).length
          }
          this.importFilter = 'all'
          this.importPage = 1
          this.$message.success(res.msg)
          this.importResultVisible = true
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      } finally {
        this.importLoading = false
      }
    },
    // 导出导入错误结果（被跳过的行）为 Excel
    exportErrors () {
      let errs = (this.importDetails || []).filter(d => d.status === 'skipped')
      if (!errs.length) {
        this.$message.info('没有需要导出的错误记录')
        return
      }
      let rows = errs.map(d => ({
        '单位名称': d.comfullname,
        '结果': '跳过',
        '说明': d.reason
      }))
      let ws = XLSX.utils.json_to_sheet(rows)
      let wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '未找到单位')
      XLSX.writeFile(wb, '黑名单导入未找到单位.xlsx')
    },
    // 导出被自动剔除的单位清单为 Excel
    exportRemoved () {
      let errs = (this.importDetails || []).filter(d => d.status === 'removed')
      if (!errs.length) {
        this.$message.info('没有需要导出的剔除记录')
        return
      }
      let rows = errs.map(d => ({
        '单位名称': d.comfullname,
        '结果': '剔除',
        '说明': d.reason
      }))
      let ws = XLSX.utils.json_to_sheet(rows)
      let wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '剔库单位')
      XLSX.writeFile(wb, '黑名单导入剔库单位.xlsx')
    },
    importPageChange (p) {
      this.importPage = p
    },
    fmtDate (v) {
      if (!v) return ''
      // 数字：Excel 序列号
      if (typeof v === 'number') {
        let d = XLSX.SSF.parse_date_code(v)
        return `${d.y}-${String(d.m).padStart(2, '0')}-${String(d.d).padStart(2, '0')}`
      }
      // Date 对象：取本地日期
      if (v instanceof Date) {
        let y = v.getFullYear()
        let m = String(v.getMonth() + 1).padStart(2, '0')
        let d = String(v.getDate()).padStart(2, '0')
        return `${y}-${m}-${d}`
      }
      // 字符串：优先按 ISO 日期时间解析（带 Z 的 UTC 串会差 8h，必须按本地时区取日期）
      let s = String(v).trim()
      if (/^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}/.test(s) || /^\d{4}-\d{2}-\d{2}Z?$/.test(s)) {
        let d = new Date(s)
        if (!isNaN(d.getTime())) {
          let y = d.getFullYear()
          let m = String(d.getMonth() + 1).padStart(2, '0')
          let dd = String(d.getDate()).padStart(2, '0')
          return `${y}-${m}-${dd}`
        }
      }
      // 普通日期字符串：2026/8/31、2026-08-31 等
      let m = s.match(/(\d{4})[\\/\-](\d{1,2})[\\/\-](\d{1,2})/)
      if (m) {
        return `${m[1]}-${String(m[2]).padStart(2, '0')}-${String(m[3]).padStart(2, '0')}`
      }
      return s.slice(0, 10)
    },
    fmtDatetime (v) {
      if (!v) return ''
      let s = String(v)
      // 2026-08-26T08:47:00.000Z => 2026-08-26 08:47:00
      if (s.indexOf('T') !== -1) {
        s = s.replace('T', ' ')
      }
      return s.replace(/\.\d{3}Z?$/, '').trim()
    },
    fmtDateOnly (v) {
      if (!v) return ''
      let s = this.fmtDatetime(v)
      return s.split(' ')[0] || s
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.toolbar-left { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.toolbar-left .el-input { width: 260px; }
.toolbar-left .el-checkbox { margin-left: 4px; }
.operate-btns { display: flex; justify-content: center; gap: 6px; white-space: nowrap; }
.result-filter { margin-top: 12px; }
.bl-table .status-tag { padding: 0 10px; height: 24px; line-height: 22px; white-space: nowrap; }
</style>
